import React from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";
import AppUtils from "@src/utils/appUtils";

const Checkbox = (props) => {
  const {
    textColor = "black",
    fontSize = "base",
    id,
    name,
    disabled,
    onChange,
    checked,
    label,
    type = "primary",
    children,
    error,
    maxWidthMd = true,
  } = props;
  return (
    <div
      className={`my-4 w-full ${
        !!maxWidthMd ? "max-w-xs md:max-w-md" : ""
      } text-left`}
    >
      <label
        htmlFor={id}
        className={`${children ? "flex" : ""} text-${fontSize} text-left
      ${type === "primary" ? "font-bold" : ""}
      ${type === "italic" ? type : ""}
      flex items-center select-none
      ${fontSize !== "base" ? `text-${fontSize}` : ""}
      ${disabled ? "text-neutral-400" : `cursor-pointer text-${textColor} active:brightness-95`}
      `}
      >
        <input
          id={id}
          name={name}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          className={"sr-only"}
          onChange={onChange}
        />
        <span
          className={`min-h-5 max-h-5 min-w-5 max-w-5 rounded-md border mr-3 flex items-center
            ${
              disabled
                ? "border-neutral-400 bg-neutral-100 cursor-not-allowed"
                : "border-black bg-white hover:shadow active:scale-95"
            }
          `}
          aria-hidden="true"
        >
          <Icon
            size="sm"
            name="checkRounded"
            textColor={
              checked ? (disabled ? "neutral-400" : "black") : "transparent"
            }
            backgroundColor="transparent"
            className={`transition-all ease-out duration-75`}
            padding={false}
          />
        </span>
        <span
          className={`${fontSize !== "base" ? `text-${fontSize}` : ""} ${disabled ? "text-neutral-400" : "text-black"}`}
        >
          {label || ""}
        </span>
        {children}
      </label>
      {error && <div className="mt-4 text-xs italic text-red-500">{error}</div>}
    </div>
  );
};

export const checkboxControls = {
  id: {
    propType: PropTypes.string,
    description: "Checkbox ID",
    controlType: "text",
    defaultValue: "checkbox-id",
  },
  name: {
    propType: PropTypes.string,
    description: "Checkbox name attribute",
    controlType: "text",
    defaultValue: "checkbox-name",
  },
  disabled: {
    propType: PropTypes.bool,
    description: "Disable the checkbox",
    controlType: "boolean",
    defaultValue: false,
  },
  checked: {
    propType: PropTypes.bool,
    description: "Checked state",
    controlType: "boolean",
    defaultValue: false,
  },
  textColor: {
    propType: PropTypes.string,
    description: "Label text color",
    controlType: "color",
    defaultValue: "black",
  },
  fontSize: {
    propType: PropTypes.string,
    description: "Label font size",
    controlType: "text",
    defaultValue: "14px",
  },
  onChange: {
    propType: PropTypes.func,
    description: "Change handler",
    disable: true,
  },
  label: {
    propType: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: "Checkbox label",
    controlType: "text",
    defaultValue: "Checkbox Label",
  },
  type: {
    propType: PropTypes.string,
    description: "Checkbox type",
    controlType: "select",
    //options: ["checkbox", "radio", "toggle"],
    options: ["primary", "italic", "other"],
    defaultValue: "checkbox",
  },
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Additional content",
    disable: true,
  },
};

Checkbox.propTypes = AppUtils.getPropTypeFromControls(checkboxControls);

export default React.memo(Checkbox);
